var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("posts", {
        attrs: {
          posts: _vm.posts,
          "is-section-show": _vm.isSectionShow,
          "is-category-show": _vm.isCategoryShow,
          "is-author-show": _vm.isAuthorShow,
        },
      }),
      _vm._v(" "),
      _vm.loading == false
        ? _c(
            "a",
            {
              staticClass: "btn btn-light btn-block",
              attrs: { href: "#" },
              on: { click: this.loadPosts },
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$root.translate("label.view_more")) +
                  "\n    "
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loading == true
        ? _c("div", { staticClass: "page-load-status" }, [_vm._m(0)])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "spinner-border", attrs: { role: "status" } },
      [_c("span", { staticClass: "sr-only" }, [_vm._v("Loading...")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }